import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const videoLinks = [
    "https://youtu.be/Kq6Dm8Ph9Fg",
    "https://youtu.be/V6hdR53dzvg",
    "https://youtu.be/c8yHGVUlFQs",
    "https://youtu.be/tXjJBWQ0WE4",
    "https://youtu.be/D8W9xd166Vk",
    "https://youtu.be/6Bl8GgiNpjo",
    "https://youtu.be/G7K9Gg-We0g",
    "https://youtu.be/ovJwkeY7F8A",
    "https://youtu.be/Plb-NxuO9Ok",
    "https://youtu.be/q8T9qswUsBE",
    "https://youtu.be/sCZskmZ6YDg",
    "https://youtu.be/E6qX5TY-IVU",
    "https://youtu.be/GcHft1MKV9Q",
    "https://youtu.be/7A0KKDeVze0",
    "https://youtu.be/VC7SeOKC7ts",
    "https://youtu.be/6DW-ke2r8-U",
    "https://youtu.be/hcuQUbx2T2w",
    "https://youtu.be/XcSMcfKS25I",
    "https://youtu.be/JtX3zzgeDA8",

];

function TrainingVideo() {
  const [toggler, setToggler] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);

  const openLightbox = (index) => {
    setActiveVideo(index);
    setToggler(!toggler);
  };

  const getYouTubeThumbnail = (url) => {
    let videoId = "";
    if (url.includes("youtu.be")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    } else if (url.includes("youtube.com")) {
      videoId = url.split("v=")[1]?.split("&")[0];
    }
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  return (
    <div className="row row--15">
      {videoLinks.map((link, index) => (
        <div className="col-lg-4 col-md-6 col-12 mt--30" key={index}>
          <div className="video-popup icon-center">
            <div className="thumbnail">
              <img
                className="radius-small"
                src={getYouTubeThumbnail(link)}
                alt={`Video ${index + 1}`}
              />
            </div>
            <div className="video-icon">
              <button
                className="btn-default rounded-player"
                onClick={() => openLightbox(index)}
              >
                <span>
                  <FiPlay />
                </span>
              </button>
            </div>
          </div>
        </div>
      ))}

      {activeVideo !== null && (
        <FsLightbox toggler={toggler} sources={[videoLinks[activeVideo]]} />
      )}
    </div>
  );
}

export default TrainingVideo;
